import { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { signOut } from '../../api/auth'
import messages from '../AutoDismissAlert/messages'

class SignOut extends Component {
  componentDidMount () {
    const { msgAlert, clearUser, user } = this.props

    signOut(user)
      .finally(() => msgAlert({
        heading: 'Signed Out Successfully',
        messagE: messages.signOutSuccess,
        variant: 'success'
      }))
      .finally(() => clearUser())
      // .finally(() => history.push('/'))
  }

  render () {
    return ''
  }
}

export default withRouter(SignOut)



// WEBPACK FOOTER //
// ./src/components/SignOut/SignOut.js